export const autoReplyCopy = {
  title: '',
  descriptionOff: '',
  descriptionOn: '',
  label: '',
};
